// extracted by mini-css-extract-plugin
export default {"landing_content":"_landing_landing_content__WnDn-","item":"_landing_item__epPIX","icon":"_landing_icon__Ndd+d","landing_infotext":"_landing_landing_infotext__Ckg9e"};